export default {"src":"/_next/static/media/Expiration.3259429c.svg","height":92,"width":91};